module.exports = __webpack_public_path__ + "img/3-4.7d836666.svg";